import { IStrings } from './dd-strings.types'

export default {
  GENERIC_ERROR_MESSAGE: 'Something went wrong! Please try again.',
} as IStrings
